import { createStore } from 'vuex'
import { getUserInfo } from '@/api-admin/login'
import { getUnreadCount } from '@/api-admin/feedback'
import { normalizeUserInfo } from '@/util/passwordSecurity'

let userInfoRequest = null

export default createStore({
  state: {
    userInfo: null,
    isLoading: false,
    unreadFeedbackCount: 0
  },
  getters: {
    userInfo: state => state.userInfo,
    isAdmin: state => state.userInfo?.role === 'admin',
    passwordChangeRequired: state => state.userInfo?.passwordChangeRequired === true,
    unreadFeedbackCount: state => state.unreadFeedbackCount
  },
  mutations: {
    setUserInfo(state, userInfo) {
      state.userInfo = userInfo
    },
    requirePasswordChange(state, status) {
      state.userInfo = {
        ...state.userInfo,
        passwordChangeRequired: true,
        passwordChangeReason: status?.passwordChangeReason || ''
      }
    },
    setLoading(state, loading) {
      state.isLoading = loading
    },
    setUnreadFeedbackCount(state, count) {
      state.unreadFeedbackCount = count
    }
  },
  actions: {
    async fetchUserInfo({ commit, state }) {
      const token = localStorage.getItem('accessToken')
      if (!token) {
        commit('setUserInfo', null)
        commit('setLoading', false)
        return
      }
      if (userInfoRequest?.token === token) return userInfoRequest.promise
      commit('setLoading', true)
      const promise = (async () => {
        try {
          const res = await getUserInfo()
          if (token !== localStorage.getItem('accessToken')) return
          if (res.code === 200 && res.data) {
            const info = normalizeUserInfo(res.data)
            // 强制改密状态只在改密成功并退出后清除。
            if (state.userInfo?.passwordChangeRequired) {
              info.passwordChangeRequired = true
              info.passwordChangeReason = state.userInfo.passwordChangeReason || info.passwordChangeReason
            }
            commit('setUserInfo', info)
          }
        } catch (error) {
          console.error('获取用户信息失败:', error)
        } finally {
          if (token === localStorage.getItem('accessToken')) commit('setLoading', false)
          if (userInfoRequest?.token === token) userInfoRequest = null
        }
      })()
      userInfoRequest = { token, promise }
      return promise
    },
    async fetchUnreadFeedbackCount({ commit }) {
      try {
        const res = await getUnreadCount()
        const count = res.code === 200 ? Number(res.data) || 0 : 0
        commit('setUnreadFeedbackCount', count)
        return count
      } catch (error) {
        console.error('获取未读反馈数量失败:', error)
        commit('setUnreadFeedbackCount', 0)
        return 0
      }
    },
    logout({ commit }) {
      commit('setUserInfo', null)
      commit('setUnreadFeedbackCount', 0)
      commit('setLoading', false)
      localStorage.removeItem('accessToken')
    }
  },
  modules: {
  }
})
